import eventTypes from 'modules/serviceWorker/constants/eventTypes';
import { pingUserAvailabilityTracking } from 'modules/queues/common/actions/pingUserAvailabilityTracking';


let worker;

const workerRegistration = () => worker = new Worker('/worker.js');

export const startAvailabilityPing = (updateAvailabilityCheckIntervalInSec) => (dispatch) => {
  return Promise.resolve()
    .then(workerRegistration)
    .then(() => worker.postMessage({ updateAvailabilityCheckIntervalInSec, messageType: eventTypes.START_TIMER }))
    .then(() => {
      worker.onmessage = ({ data: { messageType } }) => {
        if (messageType === eventTypes.SEND_PING) {
          dispatch(pingUserAvailabilityTracking());
        }
      };
    });
};

export const stopAvailabilityPing = () => {
  worker?.postMessage({ messageType: eventTypes.STOP_TIMER });
  worker?.terminate();
  worker = null;
};
